// 商户端二级品牌审核状态
export enum ExamineStatus {
    '未提交'    = 0,
    '审核通过'  = 1,
    '审核中'    = 2,
    '已撤回'    = 3,
    '驳回'      = -2
}

// 运营端二级品牌审核状态
export enum OExamineStatus {
    '审核通过'  = 1,
    '审核中'    = 2,
    '驳回'      = -2
}

// 二级品牌上下架状态
export enum Status {
    '上架'      = 1,
    '下架'      = -1,
    '已过期'    = 3
}

// 品牌分类
export enum BrandCat {
    '蛋糕'  = 1,
    '电子券' = 4,
    '零食' = 5,
    '鲜花' = 8,
    '水果' = 10,
}

// 合作方式
export enum CooperateType {
    '无',
    '普通合作' = 2,
    '预付款合作',
    '渠道对接合作',
    '官网下单',
    '不合作',
}

// 结算方式
export enum SettlementType {
    '无',
    '后结算',
    '预付款',
}

// 结算周期
export enum SettlementCycle {
    '未设置',
    '周结',
    '半月结',
    '月结',
    '半年结',
    '一单一结',
}

// 项目来源
export enum ProjectOrigin {
    '项目品牌' = 0,
    '内部创建'
}

// 操作人角色
export enum RoleList {
    '商务' = 1,
    '上架负责人',
}

// 品牌状态
export enum BrandStatus {
    '审核中',
    '待完善', // 该状态是审核通过后的状态
    '已完善', // 该状态是审核通过后的状态
    '审核失败',
}

// 品牌拓展-项目状态
export enum ProjectStatus {
    '待处理',
    '处理中',
    '审批中',
    '已完成',
    '已驳回',
}

// 品牌拓展-进度状态
export enum ProgressStatus {
    '品牌创建中',
    '商务跟进中',
    '上架负责人跟进中', // 目前是客服跟进
    '完成沟通',
    '终止沟通',
}